<style>

.grid{
  display: grid;
  grid-template-columns: auto 32px;
  color: white;
  margin-top: 15px;
}
.text{
  grid-column: 1;
}
.radio{
  grid-column: 2;
  text-align: right;
}

</style>

{#each list as item}
  <div class="grid" on:click="{ () => selectedHelper(item) }">
    <div class="text">{item}</div>
    <div class="radio">
      <i class="{item == selected ? 'icon-radio_button_on' : 'icon-panorama_fisheye'}"></i>
    </div>
  </div>
{/each}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

// export let list = [];
export let list = [
  "Item 1",
  "Item 2",
  "Item 3",
];

export let selected = "";


function selectedHelper(item) {
  selected = item;
  dispatch("updated", {text: item});
}

</script>